export const DIALOGUE_SYNC_INTERVAL_MS = 500;
export const DIALOGUE_HARD_SYNC_THRESHOLD_SECONDS = 0.75;
export const DIALOGUE_HARD_SYNC_COOLDOWN_MS = 2000;

export const shouldCorrectDialogueDrift = ({
  audioReadyState,
  audioTime,
  isSeeking,
  videoReadyState,
  videoTime,
}) => {
  if (
    isSeeking ||
    audioReadyState < 3 ||
    videoReadyState < 3 ||
    !Number.isFinite(audioTime) ||
    !Number.isFinite(videoTime)
  ) {
    return false;
  }

  return (
    Math.abs(audioTime - videoTime) >
    DIALOGUE_HARD_SYNC_THRESHOLD_SECONDS
  );
};
